<template>
    <div class="stage">
        <div class="control-width mx-auto">
            <div class="p-4 p-md-5 border shadow-sm add-rounded">
                <h4 class="mb-4 font-weight-bold text-capitalize kova-text">tell us about your project</h4>   
                <h6 class="mb-3 font-weight-bold">What stage is your project?</h6>            
                
                <!-- <label for="opt1" class="radio text-left">
                    <input type="radio" name="rdo" id="opt1" class="hidden"/>
                    <span class="label"></span>New Project
                </label><br />
                
                <label for="opt2" class="radio text-left">
                    <input type="radio" name="rdo" id="opt2" class="hidden"/>
                    <span class="label"></span>Ongoing Project
                </label><br />
                <hr /> -->
                <div class="container-fluid px-0 px-md-4 mb-5">
                    <div class="row my-5">
                        <div class="col-6 mx-auto px-1 px-sm-3 px-md-4">
                            <div class="border stage-box d-flex align-items-center mx-auto" @click="clickedNew">
                                <h6 class="kova-text font-weight-bolder mx-auto">New Project</h6>
                                <font-awesome-icon icon="check-circle" class="checked" v-if="newProject"></font-awesome-icon>
                            </div>
                        </div>
                        <div class="col-6 mx-auto px-1 px-sm-3 px-md-4">
                            <div class="border stage-box d-flex align-items-center mx-auto" @click="clickedOngoing">
                                <h6 class="kova-text font-weight-bolder mx-auto">Ongoing Project</h6>
                                <font-awesome-icon icon="check-circle" class="checked" v-if="onGoing"></font-awesome-icon>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col text-left">
                            <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack"> Back </button>
                        </div>
                        <div class="col text-right">
                            <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-right kova-text pt-3 mr-4">
                <span @click="skip">Skip <font-awesome-icon icon="step-forward"></font-awesome-icon></span>
            </div>
        </div>
        
        
 </div>
</template>
<script>
export default {
    name: 'stage',
    data(){
        return {
            newProject: false,
            isNew: false,
            onGoing: false,
            isOngoing: false,
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        next(){
            this.$router.push('hire/description')
        },
        skip(){
            this.$router.push('hire/description')
        },
        clickedNew(){
            this.newProject = true;
            this.isNew = true;
            this.onGoing = false;
            this.isOngoing = false;
        },
        clickedOngoing(){
            this.onGoing = true;
            this.isOngoing = true;
            this.newProject = false;
            this.isNew = false;
        }
    }
}
</script>
<style scoped>
.control-width{
    width: 600px;
}
.stage-box{
    height: 90px;
    width: 180px;
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}
.stage-box:hover{
    background-color: #f1f1f1
}
.checked{
    position: absolute;
    left: 190px;
    font-size: 35px;
    bottom: 45px;
    color: #4BB38E;
}
@media (min-width: 768px) and (max-width: 991px){
   
}
@media (max-width: 767px){
    .control-width{
        width:500px;
    }
}
@media (max-width: 550px){
    .control-width{
        width:98%;
    }
    .stage-box{
        height:75px;
        width: 140px;
        border-radius: 20px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    }
    .checked{
        position: absolute;
        left: 135px;
        font-size: 30px;
        bottom: 45px;
        color: #4BB38E;
    }
}
</style>